import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useLoadScript
} from "@react-google-maps/api";
import React from "react";
import { useSelector } from "react-redux";
import blueDot from "../../images/blueDot.png";
import { currentLocationSelector } from "../../store/locationStore/selectors";
import { centerSelector, zoomSelector } from "../../store/mapStore";
import MarkerWithInfoWindow from "./MarkerWithInfoWindow";
import { useRestaurants } from "./useRestaurants";

const mapStyle = { height: "90vh" };

const options = {
  zoomControl: true,
  streetViewControl: false
};

const CurrentLocationMarker = () => {
  const currentLocation = useSelector(currentLocationSelector);

  return currentLocation ? (
    <Marker
      position={{
        lat: currentLocation.lat,
        lng: currentLocation.lng
      }}
      icon={{ url: blueDot }}
    />
  ) : (
    <></>
  );
};

const RestaurantsNotOnOffer = ({
  restaurants
}: {
  restaurants: RestaurantFromAPI[];
}) => {
  return (
    <MarkerClusterer
      options={{
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
      }}
      averageCenter={true}
      enableRetinaIcons={true}
      gridSize={60}
      minimumClusterSize={3}
    >
      {clusterer =>
        restaurants.map((restaurant, i) => (
          <MarkerWithInfoWindow
            key={restaurant.key}
            restaurant={restaurant}
            clusterer={clusterer}
          />
        ))
      }
    </MarkerClusterer>
  );
};

const RestaurantsOnOffer = ({
  restaurants
}: {
  restaurants: RestaurantFromAPI[];
}) => {
  return (
    <>
      {restaurants.map(restaurant => (
        <MarkerWithInfoWindow key={restaurant.key} restaurant={restaurant} />
      ))}
    </>
  );
};

const RenderMap = () => {
  const [restaurantsOnOffer, restaurantsNotOnOffer] = useRestaurants();
  const zoom = useSelector(zoomSelector);
  const center = useSelector(centerSelector);

  const fitBounds = (map: any) => {
    const bounds = new window.google.maps.LatLngBounds();
    const restaurants = [...restaurantsOnOffer, ...restaurantsNotOnOffer];
    if (restaurants.length === 0) {
      return;
    }
    restaurants.forEach(restaurant => {
      const { lat, lng } = restaurant;
      if (lng > -10) {
        // Exclude New York
        bounds.extend(new google.maps.LatLng(lat, lng));
      }
    });
    map.fitBounds(bounds);
  };
  const [mapRef, setMapRef] = React.useState<google.maps.Map | null>(null);

  const loadHandler = (map: google.maps.Map) => {
    setMapRef(map);
    if (!center) {
      fitBounds(map);
    }
  };

  React.useEffect(() => {
    if (mapRef) {
      mapRef.panTo(center);
    }
  }, [mapRef, center]);

  React.useEffect(() => {
    if (mapRef) {
      mapRef.setZoom(zoom);
    }
  }, [mapRef, zoom]);
  return (
    <GoogleMap
      options={options}
      onLoad={loadHandler}
      mapContainerStyle={mapStyle}
      zoom={zoom}
      center={center}
    >
      <RestaurantsOnOffer restaurants={restaurantsOnOffer} />
      <RestaurantsNotOnOffer restaurants={restaurantsNotOnOffer} />
      <CurrentLocationMarker />
    </GoogleMap>
  );
};

const Map = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBWZMxbiONWRYa6S3M3mODB5HLGU0laMXk" // ,
    // ...otherOptions
  });

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  return isLoaded ? <RenderMap /> : <div style={mapStyle} />;
};

export default Map;
